import { PropsWithChildren, ReactElement } from "react";
import styles from "./ItemSelectorLayout.module.less";

export const ItemSelectorLayout = (props: PropsWithChildren<{}>): ReactElement => {
	const { children } = props;

	return (
		<div className={styles.root}>
			{children}
		</div>
	);
};
ItemSelectorLayout.displayName = "ItemSelectorLayout";

const ItemSelectorLayoutBreadcrumb = (props: PropsWithChildren<{}>): ReactElement => {
	const { children } = props;

	return (
		<div>
			{children}
		</div>
	);
};
ItemSelectorLayoutBreadcrumb.displayName = "ItemSelectorLayout.Breadcrumb";

const ItemSelectorLayoutSearch = (props: PropsWithChildren<{}>): ReactElement => {
	const { children } = props;

	return (
		<div className={styles.search}>
			{children}
		</div>
	);
};
ItemSelectorLayoutSearch.displayName = "ItemSelectorLayout.Search";

const ItemSelectorLayoutHeader = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<header className={styles.header}>
			{children}
		</header>
	);
};
ItemSelectorLayoutHeader.displayName = "ItemSelectorLayoutHeader";

const ItemSelectorLayoutContent = (props: PropsWithChildren<{}>): ReactElement => {
	const { children } = props;

	return (
		<div className={styles.content}>
			{children}
		</div>
	);
};
ItemSelectorLayoutContent.displayName = "ItemSelectorLayout.Content";

ItemSelectorLayout.Breadcrumb = ItemSelectorLayoutBreadcrumb;
ItemSelectorLayout.Search = ItemSelectorLayoutSearch;
ItemSelectorLayout.Content = ItemSelectorLayoutContent;
ItemSelectorLayout.Header = ItemSelectorLayoutHeader;